import {Layout} from '../Layout/Layout'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import React, {useState} from 'react'
import {getErrorCodeItems} from '../../config/errorCodes'
import {Button, useMediaQuery, useTheme} from '@mui/material'
import styles from '../base.module.scss'
import {StatusImage} from '../StatusImage/StatusImage'
import {stylesObject} from '../stylesObject';
import {openExternalURL} from '../../../../utils/openExternalURL';
import {redirect} from '../../../../utils/redirect';
import {mobileUtils} from '../../../../utils/mobileUtils';

export function FatalError() {
  const {t} = useTranslation('translation', {keyPrefix: 'FatalError'})
  const form = useSelector(store => store.form)
  const {fatalError, params} = form
  const theme = useTheme()
  const [mobile] = useState(mobileUtils.isMobile())

  const {finish_url} = params

  const [items] = useState(getErrorCodeItems(fatalError.code))

  let message = t('somethingWentWrong')
  if (fatalError.code && fatalError.code in {
    NO_TERMINALS_AVAILABLE: 1,
    FORM_PAY_ALREADY_SUBMITED: 1,
    FORM_PAY_ALREADY_SUBMITTED: 1,
    COMMON_ERROR: 1,
    DUPLICATE_ORDER_ERROR: 1,
    ROUTE_ERROR: 1,
  }) {
    message = t(`code.${fatalError.code}`)
  }

  return (
    <Layout
      title={'JPAY'}
    >
      {mobile ? (
        <div
          style={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className={`${styles.textSubtitle} ${styles.center}`} style={{marginBottom: '16px'}}>
            {message}
          </div>

          <div style={{flexGrow: 1}}/>

          <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
            <Button
              fullWidth
              size="large"
              variant="contained"
              sx={{
                ...stylesObject.btnPrimary,
              }}
              onClick={() => openExternalURL('https://t.me/Jussupport_bot')}
            >
              {t('support')}
            </Button>
            {finish_url && (
              <Button
                fullWidth
                size="large"
                variant="contained"
                sx={{
                  ...stylesObject.btnPrimary,
                }}
                onClick={() => redirect(finish_url)}
              >
                {t('returnToShop')}
              </Button>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            gap: '32px',
            flexGrow: 1,
          }}
        >
          <div>
            <StatusImage
              image={'failed'}
            />
          </div>
          <div style={{display: 'flex', flexDirection: 'column', flexGrow: 1}}>
            <div className={`${styles.textTitle}`} style={{marginBottom: '12px'}}>
              {message}
            </div>

            <div style={{flexGrow: 1}}/>

            <div style={{display: 'flex', marginTop: '24px', gap: '12px'}}>
              <Button
                fullWidth
                size="large"
                variant="contained"
                sx={{
                  ...stylesObject.btnPrimary,
                }}
                onClick={() => openExternalURL('https://t.me/Jussupport_bot')}
              >
                {t('support')}
              </Button>
              {finish_url && (
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  sx={{
                    ...stylesObject.btnPrimary,
                  }}
                  onClick={() => redirect(finish_url)}
                >
                  {t('returnToShop')}
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  )
}
